export default __webpack_public_path__ + "static/media/mongodb.4a790e25.svg";